"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postProcessHtml = postProcessHtml;
var changeElementType = function changeElementType(document, element, newType, copyAttributes) {
  var newElement = document.createElement(newType);
  // Copy the children
  while (element !== null && element !== void 0 && element.firstChild) {
    newElement.appendChild(element === null || element === void 0 ? void 0 : element.firstChild); // *Moves* the child
  }
  // Copy the attributes
  if (copyAttributes) {
    for (var index = 0; index < element.attributes.length; index++) {
      newElement.setAttribute(element.attributes[index].name, element.attributes[index].value);
    }
  }
  // replace the element with the new element
  element.replaceWith(newElement);
  return newElement;
};
function changeAllElementsByClassName(document, className, newType, copyAttributes) {
  var elements = document.getElementsByClassName(className);
  var iterations = elements.length;
  for (var i = 0; i < iterations; i++) {
    changeElementType(document, elements[0], newType, copyAttributes);
  }
}
function postProcessHtml(html) {
  var parser = new DOMParser();
  var document = parser.parseFromString("<body>".concat(html, "</body>"), 'text/html');

  // iterate over all paragraphs and change the base element to p
  changeAllElementsByClassName(document, 'slate-p', 'p', false);
  return document.body.innerHTML;
}